var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTeleBatteryWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_tele_battery_warning",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Box",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-car-battery",
    "data-name": "Icon awesome-car-battery",
    d: "M19.763,7.135H18.445V5.159a.659.659,0,0,0-.659-.659H13.834a.659.659,0,0,0-.659.659V7.135H7.905V5.159A.659.659,0,0,0,7.246,4.5H3.294a.659.659,0,0,0-.659.659V7.135H1.318A1.318,1.318,0,0,0,0,8.453v10.54A1.318,1.318,0,0,0,1.318,20.31H19.763a1.318,1.318,0,0,0,1.318-1.318V8.453A1.318,1.318,0,0,0,19.763,7.135Zm-11.858,5.6a.329.329,0,0,1-.329.329H2.964a.329.329,0,0,1-.329-.329v-.659a.329.329,0,0,1,.329-.329H7.576a.329.329,0,0,1,.329.329Zm10.54,0a.329.329,0,0,1-.329.329H16.469v1.647a.329.329,0,0,1-.329.329h-.659a.329.329,0,0,1-.329-.329V13.064H13.5a.329.329,0,0,1-.329-.329v-.659a.329.329,0,0,1,.329-.329h1.647V10.1a.329.329,0,0,1,.329-.329h.659a.329.329,0,0,1,.329.329v1.647h1.647a.329.329,0,0,1,.329.329Z",
    transform: "translate(1.459 -0.406)",
    fill: "#e88f25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTeleBatteryWarning);
export default __webpack_public_path__ + "static/media/ic_tele_battery_warning.c84936ce16ab994b75754f47f4679019.svg";
export { ForwardRef as ReactComponent };